import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";

// import { IntegracionAccordionDiagnostico } from "./IntegracionAccordionDiagnostico";
// import { IntegracionAccordionDocumentacion } from "./IntegracionAccordionDocumentacion";
import { postSolicitudDiscapacidad, setActiveStepDiscapacidad } from "../../../../actions/discapacidad/discapacidadActions";
import { STEPPER_INTEGRACION, TIPO_SOLICITUD_INTEGRACION } from "../../data/constants";
import { startAlerta } from "../../../../actions/ui/alertas";
import { IntegracionAccordionDiagnostico } from "./IntegracionAccordionDiagnostico";
import { AutorizacionesCard } from "../../../autorizaciones/UI/AutorizacionesCard";
import { IntegracionAccordionDocumentacion } from "./IntegracionAccordionDocumentacion";

export const IntegracionDiagnosticoDocumentacion = (props) => {
  const dispatch = useDispatch();

  const [datosCompletosDiagnostico, setDatosCompletosDiagnostico] =
    useState(false);
  const [datosCompletosDocumentacion, setDatosCompletosDocumentacion] =
    useState(false);

  const { solicitudSeleccionada } = useSelector(
    (state) => state.discapacidad
  );

  const submitHandler = (e) => {
    e.preventDefault(); 
    if (datosCompletosDocumentacion) {
      dispatch(postSolicitudDiscapacidad(
        {...solicitudSeleccionada}, 
        STEPPER_INTEGRACION.PRACTICAS
        )
      );
    } else {
      dispatch(
        startAlerta(
          `Debe completar la documentación. ${!datosCompletosDiagnostico ? "Debe agregar un diagnostico en la carga de CUD.":""}`,
          "error"
        )
      );
    }
  };
  console.log(datosCompletosDiagnostico)
  return (
    <AutorizacionesCard width={"65%"} integracion={true} >
      <ValidatorForm onSubmit={submitHandler}>
        <IntegracionAccordionDiagnostico
          datosCompletos={datosCompletosDiagnostico}
          setDatosCompletos={setDatosCompletosDiagnostico}
        />
        <IntegracionAccordionDocumentacion
          datosCompletos={datosCompletosDocumentacion}
          setDatosCompletos={setDatosCompletosDocumentacion}
          autogestion={false}
        />
        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{ marginRight: "3rem" }}
            onClick={() => {
              dispatch(setActiveStepDiscapacidad(
                (solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.ESCUELAS || 
                  solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.HOGAR)
                ? STEPPER_INTEGRACION.DETALLES_ORDEN
                : STEPPER_INTEGRACION.COMPLEMENTO_ORDEN
              )
            );
            }}
          >
            Anterior
          </Button>
          <Button variant="contained" color="primary" type="submit">
            Siguiente
          </Button>
        </div>
      </ValidatorForm>
    </AutorizacionesCard>
  );
};
